










import Vue from 'vue';
import DatasourcesList from '../components/DatasourcesList.vue';
import { fetchling } from '../hooks';
import { reactive, onMounted } from '@vue/composition-api';

export default {
  components: { DatasourcesList },
  setup(props: any, { root }: any) {
    const state = reactive({
      loading: true,
      data: [],
    });

    state.data = [];

    async function getData() {
      state.loading = true;
      try {
        const { dataTubes = [] } = await fetchling(
          'get-data-tubes',
          'datasourcesConfig',
        );
        state.data = dataTubes;
      } catch {}
      state.loading = false;
    }

    onMounted(getData);

    return { state };
  },
};
